// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"176":"projects","783":"sites","6842":"map"}[chunkId] || chunkId) + "." + {"176":"68e0c48f","783":"7978d774","2912":"80d86f38","4397":"a124fcf9","6842":"f1c74d0c"}[chunkId] + ".css";
};